
import React from 'react';
import { Expense } from '@/types/expense';
import { Card, CardContent } from '@/components/ui/card';
import { useAuth } from '@/contexts/auth';
import ExpenseTableHeader from './table/ExpenseTableHeader';
import ExpenseTableBody from './table/ExpenseTableBody';
import EmptyExpenseState from './table/EmptyExpenseState';
import { formatExpenseCurrency, formatExpenseDate } from './utils/expenseFormatters';

interface ExpenseTableProps {
  expenses: Expense[];
  currentUserId?: string;
}

const ExpenseTable: React.FC<ExpenseTableProps> = ({ expenses, currentUserId }) => {
  const { user } = useAuth();

  if (expenses.length === 0) {
    return <EmptyExpenseState />;
  }

  return (
    <Card className="border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <ExpenseTableHeader showActions={!!user} />
          <ExpenseTableBody 
            expenses={expenses} 
            currentUserId={currentUserId} 
            showActions={!!user}
            formatCurrency={formatExpenseCurrency}
            formatDate={formatExpenseDate}
          />
        </table>
      </div>
    </Card>
  );
};

export default ExpenseTable;
